import { Link } from 'react-router-dom';
import SiteContacts from '../components/SiteContacts';

export default function HowIWorkPage() {
  return (
    <article className="legal-page offer-page">
      <header className="legal-page-header">
        <h1>Как я работаю</h1>
        <p className="legal-page-nav">
          <Link to="/mini">Мини-группы и цены</Link>
        </p>
        <p className="offer-lead">
          Занятия идут на моём сайте. Ученик пишет программу здесь же: она
          запускается в браузере, проверка приходит сразу, а я вижу ту же
          работу, что и он.
        </p>
      </header>

      <div className="legal-page-body">
        <h2>Программа проверяется сразу</h2>
        <p>
          Ученик открывает задачу в браузере. Python запускается на этой же
          странице, отдельную среду на компьютер ставить не нужно. Сайт
          прогоняет решение по тестам и показывает, где ответ не сошёлся.
          Ошибку видно в тот же день, а не на следующем занятии.
        </p>

        <h2>Я вижу ход решения</h2>
        <p>
          На занятии я открываю ту же работу: код, тесты и предыдущие попытки.
          Видно, что ученик уже пробовал и на каком месте остановился. Домашнее
          задание — его собственный список задач, собранный под его план, а не
          общая пачка на всю группу.
        </p>
        <p>
          Рядом лежит прогресс по темам. По нему понятно, что уже закрыто и
          куда идти дальше, без отдельной таблицы в переписке.
        </p>

        <h2>Короткие тренажёры, пока один думает</h2>
        <p>
          К части тем есть тренажёры: каждый запуск даёт новое условие. Так
          устроены графы, логика, IP-адреса и маски, единицы измерения, строки,
          кодирование, регулярные выражения. Если ученик застрял, а я занят с
          другим, он берёт короткий тренажёр или тест по соседней теме. То же
          самое остаётся между занятиями.
        </p>

        <h2>Таблица и конспект там же</h2>
        <p>
          Задания с таблицами ученик решает в таблице на сайте. Файл не нужно
          пересылать отдельно. Конспект тоже здесь: объяснение стоит рядом с
          кодом, который можно запустить.
        </p>

        <h2>Родителю видно, что происходит</h2>
        <p>
          У родителя свой вход. Там занятия, оплата, темы и активность ребёнка.
          Расписание и сообщения лежат на сайте, рядом с задачами.
        </p>

        <h2>Зачем это на экзамене</h2>
        <p>
          На ЕГЭ рядом никого нет. Привычка самому запустить программу, увидеть
          чужой тест и поправить решение тренируется каждую неделю. Сайт
          собирает задачу, проверку, тренажёр и конспект в одном месте, чтобы
          самостоятельная работа была видна и мне, и ученику.
        </p>

        <p>
          <Link to="/mini">Как проходят мини-группы и сколько это стоит</Link>
        </p>

        <h2>Написать</h2>
        <SiteContacts variant="card" />
      </div>
    </article>
  );
}
